module.exports = __webpack_public_path__ + "img/cronometro.b8bb10f2.gif";